package com.example.mystybag.common.views

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CheckboxDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import com.arkivanov.decompose.extensions.compose.subscribeAsState
import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.common.logic.FilterBottomSheetViewModel
import com.example.mystybag.common.ui.components.native.DefaultButton
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p8
import com.example.mystybag.core.views.AppTheme

@Composable
fun FilterBottomSheetView(viewModel: FilterBottomSheetViewModel) {
    val state = viewModel.uiState.subscribeAsState()
    Column {
        state.value.title?.let {
            Texts.TitleLarge(
                modifier    = Modifier
                    .padding(bottom = p8)
                    .fillMaxWidth(),
                text        = it,
                textAlign   = TextAlign.Center
            )
        }
        state.value.filterList.forEach { model ->
            Row(
                modifier            = Modifier.fillMaxWidth(),
                verticalAlignment   = Alignment.CenterVertically
            ) {
                Checkbox(
                    checked         = model.isChecked,
                    onCheckedChange = { viewModel.onCheckboxClicked(model, it) },
                    colors          = CheckboxDefaults.colors(
                        checkedColor   = AppTheme.current.colors.primary,
                        uncheckedColor = AppTheme.current.colors.outline,
                        checkmarkColor = AppTheme.current.colors.onPrimary
                    )
                )
                Texts.BodyLarge(text = model.title)
            }
        }

        DefaultButton(
            modifier    = Modifier.padding(p16),
            caption     = state.value.buttonText ?: sharedString(SR.strings.filter),
            callback    = viewModel::onApplyClicked
        )
    }
}